import {alias, createModelSchema, list} from "serializr";
import {Schema} from "@/common/Schema";
import {BaseObject} from "@/common/BaseObject";
import {ItemKey} from "@/modules/redactor/models/item/core/ItemKey";
import {GuardConfig} from "@/modules/redactor/models/guard/GuardConfig";
import {Currency} from "@/modules/redactor/models/currency/Currency";
import {ItemAddonKind} from "@/modules/redactor/models/item-addon/ItemAddonKind";


export class ItemAddon extends BaseObject {

    constructor() {
        super();

        this._key = null;
        this._name = null;

        this._kind = null;
        this._price = [];
        this._guard = new GuardConfig();
        this._target = null;
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }


    get kind() {
        return this._kind;
    }

    set kind(value) {
        this._kind = value;
    }

    get price() {
        return this._price;
    }

    set price(value) {
        this._price = value;
    }

    get guard() {
        return this._guard;
    }

    set guard(value) {
        this._guard = value;
    }

    get target() {
        return this._target;
    }

    set target(value) {
        this._target = value;
    }

    valid() {

        if (!this.kind || ItemAddonKind.isNone(this.kind)) {
            return false;
        }

        if (!this.name || this.name.length <= 0) {
            return false;
        }

        if (!this.target || !this.target.valid() || this.target.any()) {
            return false;
        }

        if (this.guard && !this.guard.valid()) {
            return false;
        }

        if (!this.price || this.price.length === 0 || this.price.some(v => !v || !v.valid())) {
            return false;
        }

        return true;
    }

    empty() {
        return !this.id || !this.target;
    }

    copy() {
        let value = super.copy();
        value._enabled = false;
        return value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ItemAddon());
        } else if (target instanceof ItemAddon) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ItemAddon, {
    _key: alias("key", Schema.primitive()),
    _name: alias("name", Schema.primitive()),
    _kind: alias("kind", ItemAddonKind.schema()),
    _price: alias("price", list(Currency.schema())),
    _guard: alias("guard", GuardConfig.schema()),
    _target: alias("target", ItemKey.schema())
});